// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Orders report — light scoped polish, matches Accounts/Summary */

.orders-report-page {
  margin-top: 67px;
  padding: 0 16px 20px;
  box-sizing: border-box;
}

.orders-report-page .ordersReportToolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 12px;
  flex-wrap: nowrap;
}

.orders-report-page .headS {
  margin: 0;
  color: #0f172a;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
  white-space: nowrap;
  flex-shrink: 0;
}

.orders-report-page .reports {
  color: #0f172a;
  font-size: 24px;
  font-weight: 700;
  text-decoration: none;
}

.orders-report-page .reports:hover {
  color: #07a6ef;
}

.orders-report-page .crumbSep {
  margin: 0 6px;
  color: #94a3b8;
  font-size: 20px;
  font-weight: 600;
}

.orders-report-page .reporter {
  color: #0f172a;
  font-size: 24px;
  font-weight: 700;
}

.orders-report-page .ordersReportFilters {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-left: auto;
  flex-wrap: nowrap;
}

.orders-report-page .searchbarrs,
.orders-report-page .dropdownO {
  width: 150px;
  height: 36px;
  margin: 0;
  padding: 0 10px;
  color: #0f172a;
  font-size: 13px;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-sizing: border-box;
}

.orders-report-page .uploadSS {
  margin: 0;
}

.orders-report-page .choose-file-buttonn {
  width: 40px;
  height: 36px;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #79c6e9 !important;
  border: none !important;
  border-radius: 6px;
}

.orders-report-page .orderTT {
  width: 100%;
  margin: 8px 0 0;
}

.orders-report-page .Oth {
  padding: 12px 14px !important;
  color: #334155;
  font-size: 12px !important;
  font-weight: 700 !important;
  white-space: nowrap;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb !important;
}

.orders-report-page .Otd {
  padding: 12px 14px !important;
  color: #475569;
  font-size: 13px !important;
  font-weight: 500 !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

@media (max-width: 900px) {
  .orders-report-page .ordersReportToolbar {
    flex-wrap: wrap;
  }

  .orders-report-page .ordersReportFilters {
    width: 100%;
    margin-left: 0;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}

@media (max-width: 600px) {
  .orders-report-page {
    margin-top: 50px;
    padding: 0 8px 16px;
  }

  .orders-report-page .headS,
  .orders-report-page .reports,
  .orders-report-page .reporter {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Css/OrdersReport.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE;EACE,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,2BAA2B;IAC3B,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;;IAGE,eAAe;EACjB;AACF","sourcesContent":["/* Orders report — light scoped polish, matches Accounts/Summary */\r\n\r\n.orders-report-page {\r\n  margin-top: 67px;\r\n  padding: 0 16px 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.orders-report-page .ordersReportToolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin: 0 0 12px;\r\n  flex-wrap: nowrap;\r\n}\r\n\r\n.orders-report-page .headS {\r\n  margin: 0;\r\n  color: #0f172a;\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  line-height: 1.3;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.orders-report-page .reports {\r\n  color: #0f172a;\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  text-decoration: none;\r\n}\r\n\r\n.orders-report-page .reports:hover {\r\n  color: #07a6ef;\r\n}\r\n\r\n.orders-report-page .crumbSep {\r\n  margin: 0 6px;\r\n  color: #94a3b8;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.orders-report-page .reporter {\r\n  color: #0f172a;\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n}\r\n\r\n.orders-report-page .ordersReportFilters {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n  margin-left: auto;\r\n  flex-wrap: nowrap;\r\n}\r\n\r\n.orders-report-page .searchbarrs,\r\n.orders-report-page .dropdownO {\r\n  width: 150px;\r\n  height: 36px;\r\n  margin: 0;\r\n  padding: 0 10px;\r\n  color: #0f172a;\r\n  font-size: 13px;\r\n  background: #fff;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.orders-report-page .uploadSS {\r\n  margin: 0;\r\n}\r\n\r\n.orders-report-page .choose-file-buttonn {\r\n  width: 40px;\r\n  height: 36px;\r\n  margin: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #79c6e9 !important;\r\n  border: none !important;\r\n  border-radius: 6px;\r\n}\r\n\r\n.orders-report-page .orderTT {\r\n  width: 100%;\r\n  margin: 8px 0 0;\r\n}\r\n\r\n.orders-report-page .Oth {\r\n  padding: 12px 14px !important;\r\n  color: #334155;\r\n  font-size: 12px !important;\r\n  font-weight: 700 !important;\r\n  white-space: nowrap;\r\n  background: #f8fafc;\r\n  border-bottom: 1px solid #e5e7eb !important;\r\n}\r\n\r\n.orders-report-page .Otd {\r\n  padding: 12px 14px !important;\r\n  color: #475569;\r\n  font-size: 13px !important;\r\n  font-weight: 500 !important;\r\n  border-bottom: 1px solid #f1f5f9 !important;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .orders-report-page .ordersReportToolbar {\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  .orders-report-page .ordersReportFilters {\r\n    width: 100%;\r\n    margin-left: 0;\r\n    justify-content: flex-start;\r\n    flex-wrap: wrap;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .orders-report-page {\r\n    margin-top: 50px;\r\n    padding: 0 8px 16px;\r\n  }\r\n\r\n  .orders-report-page .headS,\r\n  .orders-report-page .reports,\r\n  .orders-report-page .reporter {\r\n    font-size: 20px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
